export class stockControllUtils {
    static calculateDiffernce = ( quantity = 0, expectedQuantity = 0 ) =>
        expectedQuantity < 0
            ? quantity + expectedQuantity
            : quantity - expectedQuantity;

    static formatDiferrence = ( diff = 0 ) =>
        `${diff > 0 ? "+" : ""}${diff}`;

    static parseRefId = (refId, defaultQuantity = 1) => {
        let quantity, productCode;

        if (refId.startsWith("CB+")) {
            const parts = refId.split("&_");
            productCode = parts[0].substring(3);
    

            if (parts.length > 1 && parts[1].includes("+")) {
                quantity = parts[1].split("+")[0];
            }
        } else {
            const values = refId.split("+");
            if (values.length === 1) {
                productCode = values[0];
            } else {
                quantity = values[0];
                productCode = values[1];
            }
        }
        const finalValues = quantity ? [quantity, productCode] : [productCode];
        let error = false;
        if (finalValues.length > 2 || finalValues.length < 1) {
            error = `Código inválido: ${refId}`;
        }

        if ( finalValues.length === 2 &&  (isNaN(Number(finalValues[0])) || Number(finalValues[0]) < 1) ) {
            error = `Cantidad inválida para ${finalValues[1]}: ${finalValues[0]}`;
        }

        return {
            quantity: finalValues.length === 2 ? Number(finalValues[0]) : defaultQuantity,
            sku: finalValues[finalValues.length - 1].toUpperCase(),
            error,
        };
    }

    static parseContent = text => {
        text = text.replace(/^\s*[\r\n\t]/gm, "").replace(/[']+/g, "");
        const array = text.split(new RegExp(/[\r\n\t]/gm));

        const index = array.indexOf("");
        if (index > -1)
            array.splice(index, 1);

        return array.filter(a => a !== "");
    };
    

    static formatRefId = value => {
        let formattedValue = value
            .toUpperCase()
            .replace(/[^A-Za-z0-9%+&_]/g, "");


        const specialChars = ['%', '&'];
        for (const char of specialChars) {
            while ((formattedValue.match(new RegExp(`\\${char}`, 'g')) || []).length > 1) {
                formattedValue = formattedValue.replace(new RegExp(`(?<=\\${char}.*)\\${char}`), '');
            }
        }


        while ((formattedValue.match(/\+/g) || []).length > 2) {
            formattedValue = formattedValue.replace(/(?<=\+.*\+)\+/g, '');
        }

        return formattedValue;
    }
}